module.exports = __webpack_public_path__ + "static/media/ie.7ac313fb.jpg";